module.exports = __webpack_public_path__ + "bed-button-join.5f50f031.png";